import React from 'react';
import styled from 'styled-components';

import { Typography } from 'src/typography';

type InstoreReceiptItemMobileProps = {
  productName: string;
  brandName?: string | null;
  option?: string | null;
  quantity: number;
  formattedPrice: string;
};

export function InstoreReceiptItemMobile({
  productName,
  brandName,
  option,
  quantity,
  formattedPrice,
}: InstoreReceiptItemMobileProps): JSX.Element {
  return (
    <Row data-testid='instore-receipt-item'>
      <ProductInfo>
        <ProductName tag='p' size='medium' weight='bold'>
          {productName}
        </ProductName>
        {brandName && (
          <ProductBrand tag='p' size='xsmall'>
            {brandName}
          </ProductBrand>
        )}
        <MeasurementContainer>
          <MeasurementLabel tag='span' size='small' weight='bold'>
            Weight:
          </MeasurementLabel>
          <MeasurementValue tag='span' size='small'>
            {option}
          </MeasurementValue>
          <MeasurementLabel tag='span' size='small' weight='bold' $hasLeftMargin>
            Qty:
          </MeasurementLabel>
          <MeasurementValue tag='span' size='small'>
            {quantity}
          </MeasurementValue>
        </MeasurementContainer>
      </ProductInfo>
      <Price tag='p' size='small' weight='bold' aria-label={`Price: ${formattedPrice}`}>
        {formattedPrice}
      </Price>
    </Row>
  );
}

const Row = styled.div`
  width: 100%;
  padding: 16px 0;
  color: ${({ theme }) => theme.colors.grey[30]};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
`;

const ProductName = styled(Typography.Body)`
  line-height: 1.4;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

const ProductBrand = styled(Typography.Body)`
  line-height: 165%;
`;

const MeasurementContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const MeasurementLabel = styled(Typography.Body)<{ $hasLeftMargin?: boolean }>`
  color: ${({ theme }) => theme.colors.grey[30]};
  margin-right: 2px;
  margin-left: ${({ $hasLeftMargin }) => ($hasLeftMargin ? '16px' : '0')};
  text-transform: capitalize;
  white-space: nowrap;
`;

const MeasurementValue = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.grey[30]};
  white-space: nowrap;
`;

const Price = styled(Typography.Body)`
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.grey[30]};
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 16px;
`;
